import {Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {Contact} from "../../model/contact";

@Component({
  selector: 'app-contacts-select',
  templateUrl: './contacts-select.component.html',
  styleUrls: ['./contacts-select.component.css']
})
export class ContactsSelectComponent implements OnInit {
  @ViewChild("selectTrigger") selectTrigger: ElementRef;
  @ViewChild("selectDropdown") selectDropdown: ElementRef;

  @Input() contacts: Array<Contact>;
  @Input() hasError: boolean;
  @Output() selectionChanged: EventEmitter<Array<Contact>>;

  selectOpened: boolean;
  selectValue: string;

  constructor(private readonly renderer: Renderer2) {
    this.contacts = [];
    this.selectionChanged = new EventEmitter<Array<Contact>>();

    this.selectOpened = false;
    this.selectValue = null;
  }

  ngOnInit(): void {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.selectOpened && !this.selectTrigger?.nativeElement.contains(e.target) && !this.selectDropdown?.nativeElement.contains(e.target)) {
        this.selectOpened = false;
      }
    });

    this.updateSelectValue();
  }

  toggleItem(contact: Contact): void {
    contact.selected = !contact.selected;

    this.updateSelectValue();

    this.selectionChanged.emit(this.contacts);
  }

  updateSelectValue(): void {
    let selectedContacts = this.contacts.filter(c => c.selected);

    if (selectedContacts.length > 0) {
      this.selectValue = selectedContacts.shift().title;

      if (selectedContacts.length > 0) {
        this.selectValue += `<span class="select__trigger-counter">+${selectedContacts.length}</span>`
      }
    } else {
      this.selectValue = null;
    }
  }
}
